export default class GrupoContatosModel {
  constructor({
    id = 0,
    nome = '',
    descricao = null,
    isEmail = false,
    isCelular = false,
  } = {}) {
    this.id = id
    this.nome = nome
    this.descricao = descricao
    this.isEmail = isEmail
    this.isCelular = isCelular
  }
}
